<template>
	<div v-if="isLoading">
		<LoadingOutlined /><span class="loading-text">{{ $t('settings.ftp-navigator.messages.downloadingFile') }}</span>
	</div>
	<span v-else class="file-item" @click="onClick()">
		<FileOutlined /> {{ record.name }}
	</span>
</template>

<script>
import { ref, toRef } from 'vue';
import { FileOutlined, LoadingOutlined } from '@ant-design/icons-vue';

export default {
	components: { FileOutlined, LoadingOutlined },
	props: {
		record: {
			type: Object,
			required: true,
		},
		getFile: {
			type: Function,
			required: true,
		},
	},
	setup(props) {
		const isLoading = ref(false);
		const recordRef = toRef(props, 'record');
		const onClick = () => {
			isLoading.value = true;
			props.getFile(recordRef.value.name, () => {
				isLoading.value = false;
			});
		}
		return {
			isLoading,
			onClick,
		};
	},
}
</script>

<style scoped>
.file-item {
	cursor: pointer;
	transition: color 0.3s;
}
.file-item:hover {
	color: var(--ant-primary-color, #1890ff);
}
.loading-text {
	margin-inline-start: 8px;
}
</style>
